import { Typography } from 'src/components/PulseUI';

const AddressCell = ({ row }) => {
  const addressData = row.provider?.primary_address || row?.primary_address;
  if (!addressData) return null;

  let parts: string[] = [];

  if (addressData.address) {
    const lines = addressData.address
      .split('\n')
      .map((line) => line.trim())
      .filter(Boolean);
    if (lines.length === 3) {
      // Combine street + suite, then city/state/zip
      parts = [`${lines[0]} ${lines[1]}`, lines[2]];
    } else {
      parts = lines;
    }
  } else {
    const street = [addressData.address_line_1, addressData.address_line_2]
      .filter(Boolean)
      .join(' ');
    const cityStateZip = [
      addressData.city,
      addressData.state,
      addressData.zip_code,
    ]
      .filter(Boolean)
      .join(', ');
    parts = [street, cityStateZip].filter(Boolean);
  }

  if (!parts.length) return null;

  return (
    <Typography
      variant="body2"
      block
      className="overflow-hidden text-ellipsis whitespace-nowrap"
    >
      {parts.join(', ')}
    </Typography>
  );
};

export default AddressCell;
